// extracted by mini-css-extract-plugin
export default {"CompilationList":"CompilationList_CompilationList__UvyIv","name":"CompilationList_name__zFOMQ","date":"CompilationList_date__ZBzAI","count":"CompilationList_count__BpAIa"};